<ng-container *ngIf="mergedCases?.length > 0">
  <apex-box
    class="no-padding"
    [expandable]="true"
    [expanded]="false">
    <T
      title
      str="Merged cases ({count})"
      [vars]="{ count: mergedCases?.length ?? 0 }"></T>

    <button
      right
      mat-icon-button
      type="button"
      (click)="clearSelection.emit()"
      *ngIf="showClearSelection"
      [matTooltip]="'Clear selection' | translate"
      [attr.aria-label]="'Clear selection' | translate">
      <mat-icon>clear</mat-icon>
    </button>

    <ng-container *ngFor="let mergedCase of mergedCases">
      <apex-merged-cases-list-item [mergedCase]="mergedCase"></apex-merged-cases-list-item>
      <mat-divider class="amb"></mat-divider>
    </ng-container>
  </apex-box>
</ng-container>
